import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../__root";
import { z } from "zod";

export const verifyAccountRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/verify-account",
  validateSearch: z.object({
    email: z.string(),
    token: z.string().optional(),
  }),
}).lazy(() => import("./VerifyAccount.lazy").then((d) => d.Route));
